export const formatNumber = (number) => {
    return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(number);
};

export const formatPerformNumber = (number) => {
    if (number >= 1000000) {
      return (number / 1000000).toFixed(1) + 'M'; // Millions
    } else if (number >= 1000) {
      return (number / 1000).toFixed(1) + 'K'; // Milliers
    }
    return number.toString(); // Pas de format pour les nombres inférieurs à 1000
};

export const formatDateToBar = (dateString) => {
  if (dateString == null || dateString === '') return '—';

  const raw = String(dateString).trim();
  if (!raw || raw.startsWith('0000-00-00')) return '—';

  const normalized = raw.includes('T')
    ? raw
    : raw.replace(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})/, '$1T$2');

  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return '—';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};